"use strict";

angular.module('rmStationSettings')
    .controller('StationSettingsOverviewCtrl', require('./stationsettings_overview_ctrl'))

    .controller('StationSettingsGeneralCtrl', require('./settings/stationsettings_general_ctrl'))
    .controller('StationSettingsEpgStartTimesCtrl', require('./settings/stationsettings_epg_start_times_ctrl'))
    .controller('StationSettingsThemesCtrl', require('./settings/stationsettings_themes_ctrl'))

    .controller('StationSettingsBasicInformationCtrl', require('./station-information/stationsettings_basic_information_ctrl'))
    .controller('StationSettingsContactInformationCtrl', require('./station-information/stationsettings_contact_information_ctrl'))
    .controller('StationSettingsAdvancedInformationCtrl', require('./station-information/stationsettings_advanced_information_ctrl'))
    .controller('StationSettingsLogoUrlsCtrl', require('./station-information/stationsettings_logo_urls_ctrl'))

    .controller('StationSettingsModelCtrl', require('./datamodel/stationsettings_model_ctrl'))
    .controller('StationSettingsTypeCtrl', require('./datamodel/stationsettings_type_ctrl'))
    .controller('StationSettingsFieldCtrl', require('./datamodel/stationsettings_field_ctrl'))

    .controller('StationSettingsBearersOverviewCtrl', require('./bearers/station_settings_bearers_overview_ctrl'))
    .controller('StationSettingsBearersFieldCtrl', require('./bearers/station_settings_bearers_field_ctrl'))

    .controller('StationSettingsApiPushCtrl', require('./api/stationsettings_api_push_ctrl'))
    .controller('StationSettingsApiRestOveviewCtrl', require('./api/stationsettings_api_rest_overview_ctrl'))
    .controller('StationSettingsApiRestTokenCtrl', require('./api/stationsettings_api_rest_token_ctrl'))
    .controller('SyncDialogCtrl', require('./api/sync_dialog_controller.js'))

    .controller('StationSettingsMasterCtrl', require('./multi/stationsettings_master_ctrl'))
    .controller('StationSettingsSlaveCtrl', require('./multi/stationsettings_slave_ctrl'))

    .controller('StationSettingsVisualsCtrl', require('./visuals_strings/stationsettings_visual_ctrl'))
    .controller('StationSettingsStringsCtrl', require('./visuals_strings/stationsettings_string_ctrl'))

    .controller('StationSettingsPrintRundownCtrl', require('./print_templates/stationsettings_print_rundown_ctrl'))
    .controller('StationSettingsPrintEpgCtrl', require('./print_templates/stationsettings_print_epg_ctrl'))

    .controller('StationSettingsRadioDNSCtrl', require('./export/stationsettings_radiodns_ctrl'))
    .controller('StationSettingsVTunerCtrl', require('./export/stationsettings_vtuner_ctrl'))
    .controller('StationSettingsTuneInCtrl', require('./export/stationsettings_tunein_ctrl'))
    .controller('StationSettingsDarFMOverviewCtrl', require('./export/stationsettings_darfm_overview_ctrl.js'))
    .controller('StationSettingsDarFMItemCtrl', require('./export/stationsettings_darfm_item_ctrl.js'))
    .controller('StationSettingsMetadataradioCtrl', require('./export/stationsettings_metadataradio_ctrl.js'))
    .controller('StationSettingsMetadataradioNowOnAirCtrl', require('./export/stationsettings_metadataradio_nowOnAir_ctrl.js'))

    .controller('StationSettingsApplicationsOverviewCtrl', require('./applications/stationsettings_applications_overview_ctrl'))
    .controller('StationSettingsApplicationsDetailCtrl', require('./applications/stationsettings_applications_detail_ctrl'))
    .controller('StationSettingsApplicationsMarketplaceCtrl', require('./applications/stationsettings_applications_marketplace_ctrl'))

;
